export default "__VITE_ASSET__C9O1zYav__"